import { render, staticRenderFns } from "./ListPrivilege.vue?vue&type=template&id=406f676e&scoped=true"
import script from "./ListPrivilege.vue?vue&type=script&lang=js"
export * from "./ListPrivilege.vue?vue&type=script&lang=js"
import style0 from "./ListPrivilege.vue?vue&type=style&index=0&id=406f676e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f676e",
  null
  
)

export default component.exports